module.exports = __webpack_public_path__ + "static/media/volta_redonda.fbe81018.png";